
















import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapMutations } from 'vuex';
import CloseIcon from './CloseIcon.vue';

declare let window: WindowWithAnalytics;

@Component({
  components: { CloseIcon },
  computed: mapState(['isFirstPage']),
  methods: mapMutations(['markFirstPage']),
  beforeRouteEnter(to, from, next) {
    window.analytics.track('Visit About Page');
    next();
  },
})
export default class About extends Vue {
  private isFirstPage: boolean = this.isFirstPage;
  private markFirstPage: () => void = this.markFirstPage;

  private handleClose() {
    if (this.isFirstPage) {
      this.markFirstPage();
      this.$router.replace('/');
    } else {
      this.$router.go(-1);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/About.vue